// Action enums
export enum ActionTypes {
  GET_POSSIBLE_IDEAS = "GET_POSSIBLE_IDEAS",
}
